var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttended(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "18px",
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UIKit",
    transform: "translate(-1140.000000, -1838.000000)",
    fill: "#10CCC6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1130.000000, 1829.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4807418,9.6261371 C18.8997998,8.78602659 20.1037377,8.7965653 20.5192582,9.6261371 L22.8383144,14.2802663 L28.0268934,15.0289955 C28.9573667,15.1625659 29.3302635,16.2979664 28.6554978,16.9482771 L24.9016629,20.5689258 L25.7895125,25.6835315 C25.9493254,26.6080547 24.9656158,27.2970188 24.1416845,26.8681584 L19.5,24.453214 L14.8583155,26.8681584 C14.0343842,27.3005202 13.0506746,26.6080547 13.2104875,25.6835315 L14.0983371,20.5689258 L10.3445022,16.9482771 C9.66973653,16.2979664 10.0426333,15.1625659 10.9731066,15.0289955 L16.1616856,14.2802663 L18.4807418,9.6261371 Z",
    id: "\\uF005"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttended);
export default __webpack_public_path__ + "static/media/attended.9f91cd71.svg";
export { ForwardRef as ReactComponent };